// ===============================
// Constantes
// ===============================
export const OPTIONS_DEVICES = {
    SMART: 'SMART',
    HOME: 'HOME',
    PRO_15: "PRO15_Trifasico",
};

// ===============================
// Defaults (OLD VERSION)
// ===============================
export const HOME_DATA = {
    VOLTAGE: {
        R: { min: '', max: '' },
        S: { min: '', max: '' },
    },
    CURRENT: {
        R: { min: '', max: '' },
        S: { min: '', max: '' },
    },
    POWER: {
        R: { min: '', max: '' },
        S: { min: '', max: '' },
        Σ: { min: '', max: '' },
    },
};

export const SMART_DATA = {
    VOLTAGE: {
        R: { min: '', max: '' },
        S: { min: '', max: '' },
        T: { min: '', max: '' },
    },
    CURRENT: {
        R: { min: '', max: '' },
        S: { min: '', max: '' },
        T: { min: '', max: '' },
    },
    POWER: {
        R: { min: '', max: '' },
        S: { min: '', max: '' },
        T: { min: '', max: '' },
        Σ: { min: '', max: '' },
    },
    // ✅ Potencia adquirida máxima (1 solo campo)
    ACQUIRED: {
        dmax: '',
    }
};

// ===============================
// Helpers
// ===============================
const numOrNull = (v) =>
    v == null || v === "" || Number.isNaN(Number(v)) ? null : Number(v);

const numOrZero = (v) =>
    v == null || v === "" || Number.isNaN(Number(v)) ? 0 : Number(v);

const findElement = (stringName, obj) => {
    const res = obj.find(objeto => objeto.name === stringName);
    return res?.value;
};

// ===============================
// OLD VERSION merges (SMART/HOME)
// ===============================
export const mergeDataAlarmSmart = (objData) => {
    return {
        VOLTAGE: {
            R: { min: findElement('r_vmin', objData), max: findElement('r_vmax', objData) },
            S: { min: findElement('s_vmin', objData), max: findElement('s_vmax', objData) },
            T: { min: findElement('t_vmin', objData), max: findElement('t_vmax', objData) },
        },
        CURRENT: {
            R: { min: findElement('r_imin', objData), max: findElement('r_imax', objData) },
            S: { min: findElement('s_imin', objData), max: findElement('s_imax', objData) },
            T: { min: findElement('t_imin', objData), max: findElement('t_imax', objData) },
        },
        POWER: {
            R: { min: findElement('r_pmin', objData), max: findElement('r_pmax', objData) },
            S: { min: findElement('s_pmin', objData), max: findElement('s_pmax', objData) },
            T: { min: findElement('t_pmin', objData), max: findElement('t_pmax', objData) },
            Σ: { min: findElement('tot_pmin', objData), max: findElement('tot_pmax', objData) },
        },
    };
};

export const mergeDataAlarmHome = (objData) => {
    return {
        VOLTAGE: {
            R: { min: findElement('r_vmin', objData), max: findElement('r_vmax', objData) },
            S: { min: findElement('s_vmin', objData), max: findElement('s_vmax', objData) },
        },
        CURRENT: {
            R: { min: findElement('r_imin', objData), max: findElement('r_imax', objData) },
            S: { min: findElement('s_imin', objData), max: findElement('s_imax', objData) },
        },
        POWER: {
            R: { min: findElement('r_pmin', objData), max: findElement('r_pmax', objData) },
            S: { min: findElement('s_pmin', objData), max: findElement('s_pmax', objData) },
            Σ: { min: findElement('tot_pmin', objData), max: findElement('tot_pmax', objData) },
        },
    };
};

// ===============================
// NEW VERSION merges (para mostrar en tabla)
// ===============================

// ✅ Mono new version (AHORA sí incluye adquirida para poder cargar dmax)
export const mergeMonoPhaseAlarmSmartNewVersion = (data = {}) => {
    return {
        VOLTAGE: {
            "": { min: data?.vmin ?? 0, max: data?.vmax ?? 0 },
        },
        CURRENT: {
            "": { min: data?.imin ?? 0, max: data?.imax ?? 0 },
        },
        POWER: {
            "": { min: data?.pmin ?? 0, max: data?.pmax ?? 0 },
        },
        // ✅ CAMBIO: incluir adquirida
        ACQUIRED: {
            dmax: data?.dmax ?? data?.acquired?.dmax ?? 0,
        }
    };
};

// ✅ Tri new version (Σ desde pmin/pmax y adquirida desde dmax)
export const mergeTrifasicoPhaseAlarmSmartNewVersion = (objData = {}) => {
    const totMin = objData?.pmin; // total min
    const totMax = objData?.pmax; // total max

    const hasTotal = totMin != null || totMax != null;

    return {
        VOLTAGE: {
            R: { min: numOrZero(objData?.vmin_r), max: numOrZero(objData?.vmax_r) },
            S: { min: numOrZero(objData?.vmin_s), max: numOrZero(objData?.vmax_s) },
            T: { min: numOrZero(objData?.vmin_t), max: numOrZero(objData?.vmax_t) },
        },
        CURRENT: {
            R: { min: numOrZero(objData?.imin_r), max: numOrZero(objData?.imax_r) },
            S: { min: numOrZero(objData?.imin_s), max: numOrZero(objData?.imax_s) },
            T: { min: numOrZero(objData?.imin_t), max: numOrZero(objData?.imax_t) },
        },
        POWER: {
            R: { min: numOrZero(objData?.pmin_r), max: numOrZero(objData?.pmax_r) },
            S: { min: numOrZero(objData?.pmin_s), max: numOrZero(objData?.pmax_s) },
            T: { min: numOrZero(objData?.pmin_t), max: numOrZero(objData?.pmax_t) },
            ...(hasTotal ? { "Σ": { min: numOrZero(totMin), max: numOrZero(totMax) } } : {}),
        },
        // ✅ 1 solo campo
        ACQUIRED: {
            dmax: numOrZero(objData?.dmax),
        }
    };
};

// ===============================
// transformAlarmConfig
// Convierte lo que armás en UI a lo que espera el backend (flat)
// - TRI: incluye pmin/pmax desde Σ y dmax desde acquired.dmax
// - MONO: output mono (AHORA sí manda dmax si viene en acquired)
// ===============================
export function transformAlarmConfig(config, idAux) {
    if (!config) return null;
    const id = idAux ?? config?.id ?? 0;

    // --------- CASE 1: YA VIENE TRI PLANO (backend -> vos) ----------
    const isTriFlat =
        config?.vmin_r != null || config?.vmax_r != null ||
        config?.imin_r != null || config?.imax_r != null ||
        config?.pmin_r != null || config?.pmax_r != null;

    if (isTriFlat) {
        return {
            id,
            vmin_r: numOrNull(config?.vmin_r),
            vmin_s: numOrNull(config?.vmin_s),
            vmin_t: numOrNull(config?.vmin_t),
            vmax_r: numOrNull(config?.vmax_r),
            vmax_s: numOrNull(config?.vmax_s),
            vmax_t: numOrNull(config?.vmax_t),

            imin_r: numOrNull(config?.imin_r),
            imin_s: numOrNull(config?.imin_s),
            imin_t: numOrNull(config?.imin_t),
            imax_r: numOrNull(config?.imax_r),
            imax_s: numOrNull(config?.imax_s),
            imax_t: numOrNull(config?.imax_t),

            pmin_r: numOrNull(config?.pmin_r),
            pmin_s: numOrNull(config?.pmin_s),
            pmin_t: numOrNull(config?.pmin_t),
            pmax_r: numOrNull(config?.pmax_r),
            pmax_s: numOrNull(config?.pmax_s),
            pmax_t: numOrNull(config?.pmax_t),

            // ✅ totales (flat)
            pmin: numOrNull(config?.pmin),
            pmax: numOrNull(config?.pmax),

            // ✅ adquirida
            dmax: numOrNull(config?.dmax) ?? 0,
        };
    }

    const vObj = config?.v ?? {};
    const iObj = config?.i ?? {};
    const pObj = config?.p ?? {};
    const acquiredObj = config?.acquired ?? {};

    const isTriNested =
        ["R", "S", "T"].every((k) => vObj?.[k] != null) &&
        ["R", "S", "T"].every((k) => iObj?.[k] != null) &&
        ["R", "S", "T"].every((k) => pObj?.[k] != null);

    if (isTriNested) {
        const get = (obj, phase, key) => numOrNull(obj?.[phase]?.[key]);

        const totalMin = numOrNull(pObj?.["Σ"]?.min);
        const totalMax = numOrNull(pObj?.["Σ"]?.max);

        return {
            id,
            vmin_r: get(vObj, "R", "min"),
            vmin_s: get(vObj, "S", "min"),
            vmin_t: get(vObj, "T", "min"),
            vmax_r: get(vObj, "R", "max"),
            vmax_s: get(vObj, "S", "max"),
            vmax_t: get(vObj, "T", "max"),

            imin_r: get(iObj, "R", "min"),
            imin_s: get(iObj, "S", "min"),
            imin_t: get(iObj, "T", "min"),
            imax_r: get(iObj, "R", "max"),
            imax_s: get(iObj, "S", "max"),
            imax_t: get(iObj, "T", "max"),

            pmin_r: get(pObj, "R", "min"),
            pmin_s: get(pObj, "S", "min"),
            pmin_t: get(pObj, "T", "min"),
            pmax_r: get(pObj, "R", "max"),
            pmax_s: get(pObj, "S", "max"),
            pmax_t: get(pObj, "T", "max"),

            pmin: totalMin,
            pmax: totalMax,

            dmax: numOrNull(acquiredObj?.dmax) ?? 0,
        };
    }

    // --------- MONO anidado con "" ---------
    const v = vObj?.[""] ?? {};
    const i = iObj?.[""] ?? {};
    const p = pObj?.[""] ?? {};

    return {
        id,
        vmin: numOrNull(v?.min),
        vmax: numOrNull(v?.max),
        imin: numOrNull(i?.min),
        imax: numOrNull(i?.max),
        pmin: numOrNull(p?.min),
        pmax: numOrNull(p?.max),

        // ✅ CAMBIO: ahora manda dmax si viene en acquired
        dmax: numOrNull(acquiredObj?.dmax) ?? 0,
    };
}

//Funcion q saca el guion del final del string
export function removeLastDashNumber(strAux, stateData) {
    let str = strAux
    if (!str) {
        str = stateData?.selectedNode?.realtime?.llave
    }
    if (str?.includes("-")) {
        return str.substring(0, str.lastIndexOf("-"));
    }
    return str;
}

export function getLastPartAfterDash(str, stateData) {
    if (!str) {
        str = stateData?.selectedNode?.realtime?.llave
    }
    if (str.includes("-")) {
        const lastPart = str.split("-").pop();
        return lastPart !== undefined ? Number(lastPart) : str;
    }
    return str;
}
